import api from './api';

export const filaService = {
  listar: () => api.get('/filas'),
  obter: (id: string) => api.get(`/filas/${id}`),
  criar: (data: string) => api.post('/filas', data),
  atualizar: (id: string, data: string) => api.put(`/filas/${id}`, data),
  excluir: (id: string) => api.delete(`/filas/${id}`),
};
